import React from 'react';
import OutputLine from "./OutputLine";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import ICON_TYPES from "../../../../../../src/js/misc/IconTypes";
import escapeOutputString from "../../../misc/escapeOutputString";
import MenuListOutput from "./MenuListOutput";

const propTypes = {
	indentLevel: PropTypes.number.isRequired,
	menuItem: PropTypes.object.isRequired,
};
const defaultProps = {};

const IconMenuItemOutput = ({menuItem, indentLevel}) => {
	return (
		<>
			{
				menuItem.text ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`text: '${escapeOutputString(menuItem.text || '')}',`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.url ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`url: '${encodeURI(escapeOutputString(menuItem.url || ''))}',`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.selected ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`selected: ${menuItem.selected ? 'true' : 'false'},`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.openInNewTab ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`openInNewTab: ${menuItem.openInNewTab ? 'true' : 'false'},`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.open ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`open: ${menuItem.open ? 'true' : 'false'},`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.onClick ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`onClick: ${menuItem.onClick},`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.iconType ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`iconType: '${escapeOutputString(menuItem.iconType)}',`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.iconType === ICON_TYPES.DOMNODE ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`icon: window.utahHeader.renderDOM('${escapeOutputString(menuItem.iconDom)}'),`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.iconType === ICON_TYPES.FUNCTION ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`icon: ${menuItem.iconFunction},`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.iconType === ICON_TYPES.STRING ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`icon: '${escapeOutputString(menuItem.iconString)}',`}
					</OutputLine>
					: undefined
			}

			{
				menuItem.iconType === ICON_TYPES.URL ?
					<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
						{`icon: '${encodeURI(escapeOutputString(menuItem.iconUrl))}',`}
					</OutputLine>
					: undefined
			}
			{
				(menuItem.children && menuItem.children.length) ?
					<>
						<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
							{`children: [`}
							<MenuListOutput indentLevel={indentLevel + 2} menu={menuItem.children}/>
						</OutputLine>
						<OutputLine indent={indentLevel + 1} highlightableField={menuItem.id}>
							{`],`}
						</OutputLine>
					</>
					: undefined
			}
		</>
	);
};

IconMenuItemOutput.propTypes = propTypes;
IconMenuItemOutput.defaultProps = defaultProps;

export default observer(IconMenuItemOutput);
